webpackJsonp([165660719146661],{

/***/ 204:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.previewQuery = exports.pageQuery = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Meta = __webpack_require__(6);
	
	var _Meta2 = _interopRequireDefault(_Meta);
	
	var _FooterMap = __webpack_require__(50);
	
	var _FooterMap2 = _interopRequireDefault(_FooterMap);
	
	var _graphql = __webpack_require__(56);
	
	var _graphql2 = _interopRequireDefault(_graphql);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable indent, quotes, react/prop-types */
	/* eslint-env browser */
	
	function canalWalk(page) {
	  return page.route === "/explore-downtown/riverfront-canal-walk/" ? _react2.default.createElement(_FooterMap2.default, null) : null;
	}
	
	// Interior page default template
	
	var VistityFullPage = function (_React$PureComponent) {
	  _inherits(VistityFullPage, _React$PureComponent);
	
	  function VistityFullPage() {
	    _classCallCheck(this, VistityFullPage);
	
	    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
	  }
	
	  VistityFullPage.prototype.componentDidMount = function componentDidMount() {
	    var links = [].slice.call(document.querySelectorAll(".text-block__container a"));
	    links.map(function (l) {
	      return l.setAttribute("target", "_blank");
	    });
	  };
	
	  VistityFullPage.prototype.render = function render() {
	    var data = this.props.data;
	
	    var page = data.mortyPage;
	
	    return _react2.default.createElement(
	      "div",
	      { className: "page" },
	      _react2.default.createElement(_Meta2.default, { page: page }),
	      _react2.default.createElement(
	        "div",
	        { className: "pt2 pb3 pt3-l pb5-l flex items-center justify-center flex-column" },
	        _react2.default.createElement(
	          "div",
	          { className: " w-calc-64 relative clearfix" },
	          _react2.default.createElement("iframe", {
	            className: "vistity-iframe",
	            src: "https://explore.vistity.com/tour/downtown-richmond",
	            id: "tour-iframe",
	            style: { height: '100vh', width: '100%' }
	          })
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "text-block__container w-100" },
	          _react2.default.createElement(
	            "div",
	            { className: "text-block__body p mb0 grey2" },
	            page.route !== '/live-downtown/virtual-tour/' && page.route !== '/work-downtown/virtual-tour/' ? _react2.default.createElement(
	              "h3",
	              { className: "text-block__subheadline p-emphasis h-3--l ttu dark" },
	              "If you don't see your business included in our downtown tour, please ",
	              _react2.default.createElement(
	                "a",
	                { href: "mailto:contactus@venturerichmond.com" },
	                "email"
	              ),
	              " us and we'll add it. This virtual tour is always being updated"
	            ) : null,
	            page.route === '/live-downtown/virtual-tour/' || page.route === '/work-downtown/virtual-tour/' ? _react2.default.createElement(
	              "p",
	              { className: "text-block__body p mb0 grey2" },
	              "The Downtown Richmond virtual tour offers a comprehensive overview of Downtown's economic development, featuring its eight neighborhoods, popular areas within each neighborhood, and residential and mixed-use ventures. As users navigate through the virtual landscape, they can delve into specific areas and available housing within each neighborhood. For locals and those looking to make the move to Richmond alike, it serves as a powerful tool to learn about all the opportunities and living space Downtown Richmond has to offer."
	            ) : null,
	            page.route === '/live-downtown/virtual-tour/' ? _react2.default.createElement(
	              "p",
	              { className: "text-block__body p mb0 grey2 m-t-14" },
	              "Prospective residents and tenants can explore over 150 residential projects, gaining insight into the city's booming housing landscape and potential investment opportunities."
	            ) : null,
	            page.route === '/work-downtown/virtual-tour/' ? _react2.default.createElement(
	              "p",
	              { className: "text-block__body p mb0 grey2 m-t-14" },
	              "Prospective investors and tenants can explore over 150 residential projects, gaining insight into the city's booming housing landscape and potential investment opportunities."
	            ) : null,
	            page.route === '/live-downtown/virtual-tour/' || page.route === '/work-downtown/virtual-tour/' ? _react2.default.createElement(
	              "p",
	              { className: "text-block__body p mb0 grey2 m-t-14" },
	              "As Downtown continues to evolve, Venture Richmond\u2019s Downtown Virtual Tour, which is constantly updated with the newest projects, will remain the ultimate guide for those seeking to unlock the full potential of downtown\u2019s dynamic landscape."
	            ) : null,
	            page.route === '/live-downtown/virtual-tour/' || page.route === '/work-downtown/virtual-tour/' ? _react2.default.createElement(
	              "p",
	              { className: "text-block__body p mb0 grey2 m-t-14" },
	              "If you don't see your business included in our downtown tour, please ",
	              _react2.default.createElement(
	                "a",
	                { href: "mailto:contactus@venturerichmond.com" },
	                "email"
	              ),
	              "  us and we'll add it."
	            ) : null
	          )
	        )
	      ),
	      canalWalk(page)
	    );
	  };
	
	  return VistityFullPage;
	}(_react2.default.PureComponent);
	
	exports.default = VistityFullPage;
	var pageQuery = exports.pageQuery = "** extracted graphql fragment **";
	
	var previewQuery = exports.previewQuery = "\n  query VistityFullPage($id: String!) {\n    mortyPage(id: { eq: $id }) {\n      title\n      subtitle\n      metaTitle\n      metaDescription\n      metaKeywords\n      bannerImageAltText\n      bannerImageFocalPointX\n      bannerImageFocalPointY\n      bannerImage {\n        url\n      }\n      abstract\n      abstractPhotoAltText\n      abstractPhotoFocalPointX\n      abstractPhotoFocalPointY\n      abstractPhoto {\n        url\n      }\n      route\n      slug\n      childrenMortyBlock {\n        id\n        blockType\n        content\n        headline\n        subheadline\n        buttonUrl\n        buttonTitle\n        format\n        caption\n        subcaption\n        url\n        attribution\n        focalPointX\n        focalPointY\n        altText\n        attributionAltText\n        attributionPhoto {\n          url\n        }\n        image {\n          url\n        }\n        videoType\n        videoMinutes\n        embedCode\n        attribution\n        attributionAltText\n        attributionPhoto {\n          url\n        }\n      }\n    }\n  }\n";

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-vistity-full-page-js-ddd619bb61016ca4e1a6.js